import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	MainHeaderButtonsWrapper: {
		flex: "none",
		marginLeft: "auto",
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-end",
		flexWrap: "wrap",
		gap: theme.spacing(1.25),
		"& > *": {
			margin: 0,
		},
		[theme.breakpoints.down("xs")]: {
			width: "100%",
			marginLeft: 0,
			justifyContent: "stretch",
			"& > .MuiButton-root": {
				flex: "1 1 100%",
			},
		},
	},
}));

const MainHeaderButtonsWrapper = ({ children, className = "" }) => {
	const classes = useStyles();

	return <div className={`${classes.MainHeaderButtonsWrapper} ${className}`}>{children}</div>;
};

export default MainHeaderButtonsWrapper;
